var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.mailLoad = {
	init: function () {
		$('#mc-embedded-subscribe').click(function(){
			var emailInput = document.getElementById("mce-EMAIL");
			if(emailInput && emailInput.value) {
				$('.fa-spinner').css('display', 'inline-block');
				setTimeout(function () {
					$('.fa-spinner').css('display', 'none');
				}, 2000)
			}
		})
	}
};

site.scrolled = {
	init: function () {
		site.scrolled.scroll();
		$(window).scroll(function () {
			site.scrolled.scroll();
		})
	},
	scroll: function () {
		if($(document).scrollTop() > 0) {
			$('body').addClass('scrolled');
		} else {
			$('body').removeClass('scrolled');
		}
	},
	rotor: function () {
		$rotation = $(document).scrollTop();
		$('.rotor').css('transform', 'rotate('+$rotation+'deg)');
	}
};
site.inits.push('site.scrolled.init()');

site.mainmenuToggleDesktop = {
	init: function () {
		$('#mainmenuToggleDesktop').click(function() {
			$('body').addClass('scrolled');
		})
	}
};

site.inits.push('site.mainmenuToggleDesktop.init()');


site.baseFont = {
	init: function () {
		$(window).resize(function () {
			var $baseFont = 16;
			var $baseWidth = 1905;
			var $width = $(window).width();

			var $newFont = ($width / $baseWidth) * $baseFont;
			$('html').css('font-size', $newFont+"px");

			console.log($newFont);
		})
	}
};
//site.inits.push('site.baseFont.init()');


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		setTimeout(function() {
			site.frontpage.bannerHeight();
		}, 50);


		$('.rotor > div').click(function () {
			if ($(this).hasClass('up')) {
				$('body').animate({scrollTop: 0}, 500);
			} else {
				$('body').animate({scrollTop: site.frontpage.move}, 500);
			}
		});

		$(window).resize(function () {
			site.frontpage.bannerHeight();
		})
	},

	bannerHeight: function () {
		site.frontpage.height = $(window).height();
		site.frontpage.header = $('#header').outerHeight();
		site.frontpage.move = site.frontpage.height - site.frontpage.header;
		$('#custom-promo .img').css('padding-bottom', site.frontpage.height);
	}
};

site.faqInit = function() {
	var $faq = $('.box_faqCategory');
	$faq.find('.question').click(function() {
		$(this).siblings().toggle();
		$(this).parent('li').toggleClass('open');
	});
};
site.inits.push('site.faqInit()');

site.employeesInit = function () {
	$('.employee .invis .information').slimScroll({
                height: '100%',
                size: '6px',
                color:'#ffffff',
                distance: '0',
                railVisible: true,
                railColor:'#000000',
                alwaysVisible:false
        });

	$('.branchItem').click(function () {
		var $this = $(this);
		var $search = $this.data('search');
		var wasActive = $this.hasClass('active');
		var $staff = $('.staff .employee');
		$('.branchItem').removeClass('active');

		if (!wasActive) {
			$this.toggleClass('active');
			$staff.hide();
			$staff.each(function () {
				if($(this).data('branch') == $search) {
					$(this).show();
				}

			});
		} else {
			$staff.show();
		}
	});
};
site.inits.push('site.employeesInit()');


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.mailLoad.init();
	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	if ($('body.frontpage #promo .list .item').length > 1) {
		site.owl.init('body.frontpage #promo .list', {
			items: 1,
			loop: true,
			nav: true,
			navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>']
		});
	}

	site.owl.init('.box_extras_category .testimonials .items, .frontpage .frontTestimonials .items', {
		items: 1,
		loop: true,
		nav: true,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>']
	});

	site.owl.init('.box_galleryimage ul', {
		items: 6,
		loop: true,
		nav: true,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive: {
			0: {
				items: 2
			},
			768: {
				items: 3
			},
			992: {
				items: 4
			},
			1200: {
				items: 5
			}
		}
	});

	$body.addClass('loaded');
	$('.image').addClass('loaded');

});
